class Accordion extends HTMLElement {
    constructor() {
        super();
        this.isOpen = this.classList.contains("open");
        this.addEventListener('click', () => {
            this.toggle();
        });

        

        this.addEventListener('focus', () => {
            this.open();
          });
    
        this.addEventListener('focusout', () => {

            setTimeout(() => {
                if (!this.contains(document.activeElement)) this.close();
            })

        });
    }

    toggle() {
        if (this.isOpen) this.close();
        else this.open();
    }

    open() {
        this.classList.add("open");
        if (this.classList.contains("closed")) this.classList.remove("closed");
        this.isOpen = true;
    }

    close() {
        this.classList.add("closed");
        if (this.classList.contains("open")) this.classList.remove("open");
        this.isOpen = false;
    }
}

customElements.define('accordion-menu', Accordion)